// Универсальный пушер
function dlPush(payload) {
    try {
        window.dataLayer = window.dataLayer || [];
        const s = JSON.stringify(payload);
        if (s.length > 8000) console.warn('[ecom] payload ~', s.length, ' (>8KB)');
        window.dataLayer.push(payload);
    } catch (e) {
        console.error('[ecom] push error', e, payload);
    }
}

// Валюта проекта
const CURRENCY = 'RUB'; // при необходимости смените на 'AMD'

export function mapProduct(p, {list, position, qty = 1} = {}) {
    const price =
        Number(p?.price_per_meter ?? p?.price_per_ton ?? p?.price_per_piece ?? p?.price ?? 0);

    const variant =
        p?.price_per_meter != null ? 'м' :
            p?.price_per_ton != null ? 'т' :
                p?.price_per_piece != null ? 'шт' : undefined;

    const categoryPath = Array.isArray(p?.category_path)
        ? p.category_path.slice(0, 5).join(' / ')
        : (p?.category_path || p?.category?.title || undefined);

    return {
        id: String(p?.id ?? ''),
        name: p?.title || 'Товар',
        price,
        quantity: qty,
        brand: p?.brand?.title || p?.brand?.name || 'Металлопрокат-1',
        category: categoryPath,
        variant,
        ...(list ? {list} : {}),
        ...(position ? {position} : {}),
    };
}

export function ecomClick(product) {
    dlPush({ecommerce: {currencyCode: CURRENCY, click: {products: [product]}}});
}

export function ecomDetail(product) {
    dlPush({ecommerce: {currencyCode: CURRENCY, detail: {products: [product]}}});
}

export function ecomAdd(product) {
    dlPush({ecommerce: {currencyCode: CURRENCY, add: {products: [product]}}});
}

export function ecomRemove(product) {
    dlPush({ecommerce: {currencyCode: CURRENCY, remove: {products: [product]}}});
}

export function ecomPurchase({orderId, revenue, products, coupon, goalId}) {
    dlPush({
        ecommerce: {
            currencyCode: CURRENCY,
            purchase: {
                actionField: {
                    id: String(orderId),
                    ...(typeof revenue === 'number' ? {revenue} : {}),
                    ...(coupon ? {coupon} : {}),
                    ...(goalId ? {goal_id: goalId} : {}),
                },
                products
            }
        }
    });
}
